module.exports = __webpack_public_path__ + "static/appstore-fr-30d3356c01e4abf436b3e1ef8d56625a.png";